import '../../shared/footer_newsletter/footer_newsletter'

import { currentDevice } from '../../core/utils/currentDevice.js'
import { getPrefix } from '../../core/utils/locale.js'
import { createAndShowHtmlSheet } from '../../shared/bottom_sheet/bottom_sheet.js'
import { getLazyData } from '../../utils/get_lazy_data'

import { initializeUtagEvents } from './footer.analytics'

/* eslint-disable */
if (IB.currentDevice === 'mobile') {
  let $doc = $(document);
  let $footer_nav = $('.footer-nav');

  $footer_nav.find('.footer-nav-content span').remove();
  $footer_nav.find('[data-children]').hide();
  $footer_nav.find('[data-parent]').hide();
  $footer_nav.find('.menu_item').not('.title').hide();

  $doc.on('click', '.footer-nav .title a ', function (event) {

    let $this = $(this);


    if (IB.current_microsite === 'ibercuba' && $this.hasClass('manage-bookings') && $this.hasClass('title')) {
      return;
    } else {
      event.preventDefault();
    }

    $('.footer-bottom-mobile').removeClass('opened');
    $('.footer-contact .opened').removeClass('opened');
    cleanNavs();

    if ($this.parent('li').hasClass('menu_item') && !$this.hasClass('opened')) {
      $this.addClass('opened');
      $footer_nav.find('.opened').not(this).removeClass('opened');
      $this.parent().parent().parent()
        .addClass('opened-container-mobile');
      $this.addClass('opened').closest('ul').find('.menu_item')
        .not('.title')
        .show();
    } else {
      $this.removeClass('opened');
      $this.closest('ul').find('.menu_item').not('.title')
        .hide();
      $footer_nav.find('.title a').not(this).removeClass('opened');
    }
  });

  $doc.on('click', '.footer-nav .hotels-link a', function (event) {
    event.preventDefault();
    let $this = $(this);

    $('.hotels-nav-container li').removeClass('title');
    $('.footer-contact .opened').removeClass('opened');
    $('.footer-bottom-mobile').removeClass('opened');
    cleanNavs();

    if (!$this.hasClass('opened')) {
      $this.addClass('opened');
      $footer_nav.find('.opened').removeClass('opened');
      $this.addClass('opened');
      $footer_nav.find('[data-parent]').show();
      $('.hotels-nav-container').addClass('opened-container-mobile');
      $this.closest('.hotels-nav-container').find('.menu_item').show();
    } else {
      $this.removeClass('opened');
      $this.closest('.hotels-nav-container').find('.menu_item').hide();
    }
  });

  $doc.on('click', '.footer-contact .footer-contact-us-mobile', function (event) {
    event.preventDefault();
    let $this = $(this);

    $('.footer-bottom-mobile').removeClass('opened');
    cleanNavs();

    if (!$this.hasClass('opened')) {
      $footer_nav.find('.opened').removeClass('opened');
      $this.addClass('opened');
      $this.parent().parent().addClass('opened-container');
      $('.footer-contact-left').show();
    } else {
      $('.footer-contact a').removeClass('opened');
      $('.footer-contact-left').hide();
    }
  });

  $doc.on('click', '.footer-contact .footer-bottom-mobile', function (event) {
    event.preventDefault();
    let $this = $(this);

    cleanNavs();

    if (!$this.hasClass('opened')) {
      $footer_nav.find('.opened').removeClass('opened');
      $('.footer-contact').find('.title a').not(this)
        .removeClass('opened');
      $this.addClass('opened');
      $this.parent().parent().parent()
        .addClass('opened-container');
      $('.xsmall').show();
    } else {
      $('.footer-contact a').removeClass('opened');
      $('.xsmall').hide();
    }
  })

} else {
  let $doc = $(document);
  let $footer_nav = $('.footer-nav');

  $doc.on('click', '.footer-nav .dropdown.title', function (event) {
    event.preventDefault();
    let $this = $(this);

    if (!$this.parent().hasClass('opened-container')) {
      $('.footer-nav div').removeClass('opened-container');
      $footer_nav.find('.opened-container').removeClass('opened-container');
      $this.parent().addClass('opened-container');
    } else {
      $this.parent().removeClass('opened-container');
    }
  });
}

function cleanNavs() {
  let $footer_nav = $('.footer-nav');
  $('.footer-contact .opened-container').removeClass('opened-container');
  $('.footer-contact .xsmall').hide();
  $('.footer-contact .footer-contact-left').hide();
  $footer_nav.find('hotels-nav-content').hide();
  $footer_nav.find('[data-parent]').hide();
  $footer_nav.find('.menu_item').not('.title').hide();
  $footer_nav.find('.opened-container-mobile').removeClass('opened-container-mobile');
}

function updateBookingsUrl() {
  if(!IB.current_microsite && IB?.browsing_sessions?.isUserLogged()) {
    const element = $('.manage-bookings-nav-container.footer-panel-col')
    let url = element.data('bookings-url')
    $('.js-mis-reservas-footer').prop('href', url);
  }
}

function updateFooterLanguageSelectorHrefs() {
  const footerLangSelector = document.querySelector('.js-footer-contact .js-language-selector')
  const availableLanguages = window.ibh?.lang?.list

  if (!footerLangSelector || typeof availableLanguages === 'undefined' || typeof availableLanguages !== 'object') return

  Object.entries(availableLanguages).forEach(([key, value]) => {
    const langItem = footerLangSelector.querySelector(`[data-locale="${key}"]`)
    if (!langItem) return
    langItem.href = value.url
  });
}

$(document).ready(function () {
  const microsite = document.querySelector('#microsite')?.value
  if (microsite !== 'star_agents') initFooterCookiesDialog();
  initializeUtagEvents();
  updateBookingsUrl()

  $('.footer-nav span').addClass('title');

  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(userAgent)) {
    $('.footer-social-media.secondary-btn').prop('href', 'https://play.google.com/store/apps/details?id=com.mo2o.iberostar&hl=es');
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    $('.footer-social-media.secondary-btn').prop('href', 'https://itunes.apple.com/es/app/iberostar-hotels-resorts-reserva/id922530529?mt=8');
  }

  updateFooterLanguageSelectorHrefs()
});


$(document).on('click', '[data-tealium-cookies-config]', function (e) {
  e.preventDefault();
  if (utag !== undefined && utag.gdpr !== undefined && IB.cookieManager.isGA) {
    utag.gdpr.showConsentPreferences();
  }
});



function initFooterCookiesDialog() {
  const btnPolicyCookiesFooter = document.querySelector('.js-footer-legal-links .cookie-policy')
  btnPolicyCookiesFooter.setAttribute("data-cookies-policy-modal-trigger", "modal-cookies-policy-id");
  const url = `${getPrefix()}/ajax_contents/lightbox_cookies_policy?fancybox=true`
  //Add event listener to btnPolicyCookiesFooter to throw getLazy data and show modal
  btnPolicyCookiesFooter.addEventListener('click', (e) => {
    e.preventDefault();
    getLazyData(url, function (modalHtml) {
      if (currentDevice.isMobile) {
        createAndShowHtmlSheet({
          html: modalHtml
        })
      } else {
        Modal.showHtml({
          openTrigger: 'data-cookies-policy-modal-trigger',
          title: 'Cookies policy',
          html: modalHtml,
          onShow: () => {
            ScrollLock.on();
          },
          onClose: () => {
            ScrollLock.off();
          },
          awaitCloseAnimation: true,
        });
      }
    });
  });
}
